import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type FlagIconProps = IconProps;

export const FlagIcon = forwardRef<SVGSVGElement, FlagIconProps>(
  function FlagIcon(props: FlagIconProps, ref) {
    return (
      <Icon
        data-testid="FlagIcon"
        aria-label="flag"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M3.754 0c.477 0 .941.043 1.395.129.453.078.898.164 1.336.258.43.086.859.176 1.289.27.437.094.891.141 1.359.141.305 0 .594-.016.867-.047.273-.039.523-.07.75-.094.125-.016.34-.039.644-.07.313-.039.512-.07.605-.086v7a40.84 40.84 0 0 1-.605.094c-.305.047-.52.078-.644.094-.219.023-.461.051-.727.082s-.547.047-.844.047c-.5 0-.984-.039-1.453-.117a52.119 52.119 0 0 1-1.371-.27 18.893 18.893 0 0 1-1.301-.328 4.265 4.265 0 0 0-1.289-.199c-.617 0-1.035.035-1.254.105a3.952 3.952 0 0 0-.512.167v4.825h-1V.552L1.14.458c.031-.023.234-.105.609-.246C2.132.071 2.8.001 3.753.001zm.012.949c-.609 0-1.027.039-1.254.117-.219.078-.387.141-.504.188L2 6.25c.203-.062.422-.113.641-.168C2.868 6.027 3.243 6 3.766 6c.477 0 .938.062 1.383.188.453.117.898.223 1.336.316l1.23.27c.39.086.82.129 1.289.129.297 0 .648-.016 1.055-.047.406-.039.715-.074.941-.105V1.606c-.227.023-.512.055-.871.094s-.687.059-.984.059c-.508 0-.988-.051-1.441-.152a48.659 48.659 0 0 0-1.348-.305 26.23 26.23 0 0 0-1.301-.246A7.867 7.867 0 0 0 3.766.951z" />
      </Icon>
    );
  }
);
